import * as React from "react";
import {FBFieldBase, FBFieldBaseProps, FBFieldBaseState} from "./FBFieldBase";
import {SubFieldPrice} from "./SubComponents/SubFieldPrice";

import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";

export abstract class FBFieldWithPriceBase<p extends FBFieldWithPriceBaseProps=FBFieldWithPriceBaseProps,s extends FBFieldWithPriceBaseState=FBFieldWithPriceBaseState> extends FBFieldBase<p, s> {
    static defaultProps: Partial<FBFieldWithPriceBaseProps> = {};

    PriceBox:SubFieldPrice;


    constructor(props: p) {
        super(props);

    }



    public GetPriceOrRequiredBox(){

        return(
            <SubFieldPrice Immediate={this.Model.ImmediateAnimation} Model={this.Model as FBFieldWithPriceBaseModel}/>
        )

    }




    componentDidMount(): void {
        super.componentDidMount();
        if(this.PriceBox!=null)
            this.PriceBox.Refresh();
        this.Model.ImmediateAnimation=false;
        this.FormBuilder.PriceManager.AddField(this.Model);
    }


    componentWillUnmount(): void {
        this.FormBuilder.PriceManager.RemoveField(this.Model);
    }


    StoresInformation(): boolean {
        return true;
    }

    componentDidUpdate(prevProps: Readonly<p>, prevState: Readonly<s>, snapshot?: any): void {
        //if(this.state.Quantity!=prevState.Quantity)
    }






}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface FBFieldWithPriceBaseProps  extends FBFieldBaseProps{
    Model:FBFieldWithPriceBaseModel;
}

export interface FBFieldWithPriceBaseState extends FBFieldBaseState{

}

//#endregion "My Region"